class CookieConsent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <style>
        .cookie-consent {
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          max-width: 500px;
          width: 90%;
          background: #fff;
          color: #333;
          font-size: 14px;
          border-radius: 12px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
          padding: 20px;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          gap: 16px;
          font-family: "Segoe UI", system-ui, sans-serif;
          transition: opacity 0.3s ease, transform 0.3s ease;
        }

        .cookie-consent.hide {
          display: none;
        }

        .cookie-content {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }

        .cookie-content i {
          font-size: 22px;
          color: #f1c40f;
          flex-shrink: 0;
        }

        .cookie-text {
          line-height: 1.5;
        }

        .cookie-text a {
          color: #007bff;
          text-decoration: underline;
        }

        .cookie-actions {
          display: flex;
          justify-content: flex-end;
        }

        .allow-button {
          padding: 10px 18px;
          background-color: #28a745;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
          transition: background-color 0.2s ease;
        }

        .allow-button:hover {
          background-color: #218838;
        }

        @media (max-width: 480px) {
          .cookie-consent {
            bottom: 10px;
            padding: 16px;
            font-size: 13px;
          }

          .allow-button {
            padding: 8px 14px;
            font-size: 13px;
          }
        }
      </style>

      <div class="cookie-consent hide" role="alert" aria-live="polite">
        <div class="cookie-content">
          <i class="fas fa-cookie-bite" aria-hidden="true"></i>
          <div class="cookie-text">
            Utilizamos cookies essenciais e tecnologias semelhantes conforme a nossa
            <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>.
            Ao continuar navegando, você concorda com estas condições.
          </div>
        </div>
        <div class="cookie-actions">
          <button class="allow-button" aria-label="Aceitar cookies">Entendi</button>
        </div>
      </div>
    `;

    const consentBox = this.querySelector(".cookie-consent");
    if (document.cookie.indexOf("cookie-consent=1") === -1) {
      consentBox.classList.remove("hide");
    }

    const allowButton = this.querySelector(".allow-button");
    allowButton.addEventListener("click", () => {
      document.cookie = "cookie-consent=1; path=/; max-age=31536000";
      consentBox.classList.add("hide");
    });
  }
}

window.customElements.define("cookie-consent", CookieConsent);
